export class Chart {
    constructor(id, name, roots) {
        this.id = id;
        this.name = name;
        this.roots = roots;
        this.incomeStatement = roots[1];
        this.balanceSheet = roots[0];
    }
}
